export default "__VITE_ASSET__EwALUeDI__"